module.exports = __webpack_public_path__ + "img/dashboard-card-2.87c0403d.svg";